const furnishingBasePath = '/furnishings';


const FurnishingConst = {
   basePath: furnishingBasePath,
};

export default FurnishingConst;